import React, { useState, useEffect, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import BaseUrl from "../../Components/BaseUrl";
import axios from "axios";
import swal from "sweetalert2";
import {
  FaRegHeart,
  FaHeart,
  FaRegComment,
  FaRegShareSquare,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { MdOutlineEdit } from "react-icons/md";
import { BiWorld } from "react-icons/bi";
import { IoMdAdd } from "react-icons/io";
import { MdClose } from "react-icons/md";
import { FaCamera } from "react-icons/fa";
import { FaUserGroup } from "react-icons/fa6";
import { IoIosAddCircleOutline } from "react-icons/io";
import Cropper from "react-easy-crop";
import { getCroppedImg } from "./cropUtils";
import { getCroppedProfileImg } from "./CropUtilss";
import { useCallback } from "react";
import PostModal from "../../Modals/PostModal";

const ProfileUser = () => {
  const [isloading, setIsLoading] = useState(true);
  const isFormatActive = (editor, format) => {
    const [match] = Array.from(editor.children)
      .flatMap((node) => node.children)
      .filter((leaf) => leaf[format]);
    return !!match;
  };

  const navigate = useNavigate();
  const profile = useRef(null);
  const bg_profile = useRef(null);
  const [image, setImage] = useState(null);
  const [pimage, setPImage] = useState(null);
  const [bgpreview, setBgPreview] = useState(null);
  const [preview, setPreview] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedArea, setCroppedArea] = useState(null);
  const [inputKey, setInputKey] = useState(Date.now());
  const [isModalProfile, setIsModalProfile] = useState(false);
  const [isResource, setIsResource] = useState(false);
  const [isModalBgProfile, setIsModalBgProfile] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [isPostOpen, setIsPostOpen] = useState(false);
  const [isPostSettingOpen, setIsPostSettingOpen] = useState(false);
  const [isEducationOpen, setIsEducationopen] = useState(false);
  const [isExperienceOpen, setIsExperienceopen] = useState(false);
  const [isSkillOpen, setIsSkillopen] = useState(false);
  const [iscontactOpen, setIsContactopen] = useState(false);
  const [issummaryOpen, setIsSummaryopen] = useState(false);
  const [isAboutOpen, setIsAboutopen] = useState(false);
  const [selectedEdu, setSelectedEdu] = useState(null);
  const [selectedExperience, setSelectedExperience] = useState([]);
  const [selectedEducation, setSelectedEducation] = useState([]);
  const [followSkill, setFollowSkill] = useState(false);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [skillValue, setSkillValue] = useState("");
  const [summaryValue, setSummaryValue] = useState("");
  const [summaryerror, setSummaryError] = useState({});
  const inputRef = useRef(null);
  const [checkedSkills, setCheckedSkills] = useState([]);
  const skillsRef = useRef([]);
  const [skills, setSkills] = useState([]);
  const [skillerror, setskillError] = useState({});
  const [filteredSkills, setFilteredSkills] = useState([skillsRef.current]);
  const [education, setEducation] = useState([]);
  const [experience, setExperience] = useState([]);
  const [experiencedata, setExperiencedata] = useState([]);
  const [educationdata, setEducationdata] = useState([]);
  const [skilldata, setSkilldata] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedbgImage, setSelectedBgImage] = useState(null);
  const [postdata, setPostdata] = useState([]);
  const [post, setPost] = useState([]);

  const options = ["Male", "Female", "Other"];
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const years = Array.from(
    { length: new Date().getFullYear() - 1950 + 1 },
    (_, i) => 1950 + i
  ).reverse();
  const dates = Array.from({ length: 31 }, (_, i) => i + 1);

  const [introformData, setIntroFormData] = useState({
    name: "",
    email: "",
    add_name: "",
    gender: "",
    headline: "",
    position: "",
    industry: "",
    website: "",
    country: "",
    city: "",
    summary: "",
    profile_image: "",
    cover_image: "",
  });
  const [introerror, setIntroError] = useState({});

  const [contactformData, setContactFormData] = useState({
    phone_number: "",
    phone_type: "",
    address: "",
    birthday_month: "",
    birthday_date: "",
  });
  const [contactError, setContactError] = useState({});

  const [educationformData, setEducationFormData] = useState({
    school: "",
    degree: "",
    field_of_study: "",
    start_month: "",
    start_year: "",
    end_month: "",
    end_year: "",
    grade: "",
    activities: "",
    description: "",
    skills: [],
    media: [],
  });
  const [educationError, setEducationError] = useState({});

  const [experienceformData, setExperienceFormData] = useState({
    title: "",
    employment_type: "",
    company: "",
    start_month: "",
    start_year: "",
    end_month: "",
    end_year: "",
    location: "",
    location_type: "",
    description: "",
    headline: "",
    findjob: "",
    skills: [],
    media: [],
  });
  const [experienceError, setExperienceError] = useState({});
  const [skillsError, setSkillsError] = useState({});

  const [likedPosts, setLikedPosts] = useState({}); 
  const [commentlikes, setCommentLikes] = useState({});
  const [commentlikedPosts, setCommentLikedPosts] = useState({});

  useEffect(() => {
    const id = Cookies.get("userId");
    console.log(id);
    getPosts();
    getProfileData(id);
  }, []);

  const getPosts = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(BaseUrl + "getposts", {
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
      const fetchedPosts = response.data.data;
      const comments = response.data.data.map((post) => post.comments);
  
      setPostdata(response.data.data);
      setPost(response.data.data[0]);
      
      const initialLikes = {};
      const initialLikedStatus = {};
      const initialcommentLikes = {};
      const initialcommentLikedStatus = {};
      const initialComments = {};
  
      fetchedPosts.forEach((post) => {
        initialLikes[post.id] = post.likes;
        initialLikedStatus[post.id] = post.has_liked;
        initialComments[post.id] = post.comments;
      });
  
      comments.forEach((comment) => {
        comment.forEach((comment) => {
          initialcommentLikes[comment.comment_id] = comment.comment_likes;
          initialcommentLikedStatus[comment.comment_id] = comment.has_liked_comment;
        });
      });
  
      // setInitialLikes(initialLikes);
      setLikes(initialLikes);
      setLikedPosts(initialLikedStatus);
      // setRecievedComments(initialComments);
      setCommentLikes(initialcommentLikes);
      setCommentLikedPosts(initialcommentLikedStatus);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };


  const getProfileData = async (id) => {
    setIsLoading(true);
    try {
      const response = await axios.get(BaseUrl + `users`,{
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
      }});
      const response2 = await axios.get(BaseUrl + "skills");

      skillsRef.current = response2.data;
      setSkills(response2.data);
      setFilteredSkills(response2.data);

      profile.current = response.data.data.profile_image;
      bg_profile.current = response.data.data.cover_image;

      setIntroFormData(response.data.data);
      setContactFormData(response.data.data.contact_info);
      setSummaryValue(response.data.data.summary);
      setExperiencedata(response.data.data.experience);
      setEducationdata(response.data.data.education);
      setSkilldata(response.data.data.userskill);

      const schools = response.data.data.education?.map((edu) => ({
        id: edu.id,
        name: edu.school,
      }));

      const experience = response.data.data.experience?.map((exp) => ({
        id: exp.id,
        name: exp.company,
      }));

      setExperience(experience);
      setEducation(schools);
      setSelectedEdu(schools.length > 0 ? schools[0].name : "");
    } catch (error) {
      console.error("Error fetching profile data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const openResources = () => {
    setIsResource(true);
  };
  const closeResources = () => {
    setIsResource(false);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const openModalProfile = () => {
    setIsModalProfile(true);
  };
  const closeModalProfile = () => {
    setIsModalProfile(false);
    setPreview(null);
    setSelectedImage(null);
  };

  const openModalBgProfile = () => {
    setIsModalBgProfile(true);
  };
  const closeModalBgProfile = () => {
    setIsModalBgProfile(false);
    setBgPreview(null);
  };

  const postopenModal = () => {
    setIsPostOpen(true);
  };
  const postcloseModal = () => {
    setIsPostOpen(false);
  };

  const postsettingopenModal = () => {
    setIsPostSettingOpen(true);
  };
  const postsettingcloseModal = () => {
    setIsPostSettingOpen(false);
  };

  const educationopenModal = () => {
    setIsEducationopen(true);
  };
  const educationcloseModal = () => {
    setIsEducationopen(false);
  };

  const experienceopenModal = () => {
    setIsExperienceopen(true);
  };
  const experiencecloseModal = () => {
    setIsExperienceopen(false);
  };

  const skillopenModal = () => {
    setIsSkillopen(true);
  };
  const skillcloseModal = () => {
    setIsSkillopen(false);
  };

  const contactopenModal = () => {
    setIsContactopen(true);
  };
  const contactcloseModal = () => {
    setIsContactopen(false);
  };

  const summaryopenModal = () => {
    setIsSummaryopen(true);
  };
  const summarycloseModal = () => {
    setIsSummaryopen(false);
  };
  const aboutopenModal = () => {
    setIsAboutopen(true);
  };
  const aboutcloseModal = () => {
    setIsAboutopen(false);
  };

  const openaddskillmodal = () => {
    setCheckedSkills([...selectedSkills]);
    setShowModal(true);
  };
  const handleExperienceChange = (expId) => {
    setSelectedExperience((prev) =>
      prev.includes(expId)
        ? prev.filter((id) => id !== expId)
        : [...prev, expId]
    );
  };
  const handleEducationChange = (eduId) => {
    setSelectedEducation((prev) =>
      prev.includes(eduId)
        ? prev.filter((id) => id !== eduId)
        : [...prev, eduId]
    );
  };

  const handleCheckboxChange = (skill) => {
    setCheckedSkills((prev) =>
      prev.includes(skill) ? prev.filter((s) => s !== skill) : [...prev, skill]
    );
  };

  const saveexperienceSkills = () => {
    setExperienceFormData((prev) => ({
      ...prev,
      skills: checkedSkills,
    }));
    setShowModal(false);
  };
  const saveeducationSkills = () => {
    setEducationFormData((prev) => ({
      ...prev,
      skills: checkedSkills,
    }));
    setShowModal(false);
  };

  const onintroformDataChange = (e) => {
    const { id, value } = e.target;
    setIntroFormData((prevData) => ({ ...prevData, [id]: value }));
    setIntroError((prevData) => ({ ...prevData, [id]: "" }));
  };

  const oncontactformDataChange = (e) => {
    const { id, value } = e.target;
    setContactFormData((prevData) => ({ ...prevData, [id]: value }));
    setContactError((prevData) => ({ ...prevData, [id]: "" }));
  };
  const oneducationformDataChange = (e) => {
    const { id, value } = e.target;
    setEducationFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
    setEducationError((prevData) => ({ ...prevData, [id]: "" }));
  };

  const onexperienceformDataChange = (e) => {
    const { name, value } = e.target;
    setExperienceFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setExperienceError((prevData) => ({ ...prevData, [name]: "" }));
  };

  const validateintroForm = () => {
    let result = true;
    let errors = {};
    if (introformData.name === "") {
      errors.name = "Please enter your name";
      result = false;
    }
    if (introformData.headline === "") {
      errors.headline = "Please enter your headline";
      result = false;
    }
    if (introformData.position === "") {
      errors.position = "Please enter your position";
      result = false;
    }
    if (introformData.industry === "") {
      errors.industry = "Please enter your industry";
      result = false;
    }
    if (introformData.country === "") {
      errors.country = "Please enter your country";
      result = false;
    }
    setIntroError(errors);
    return result;
  };

  const handleintroformsubmit = async (e) => {
    e.preventDefault();
    const result = validateintroForm();
    if (result) {
      const response = await axios.post(
        BaseUrl + `users/editaccount`,
        introformData,{
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
      console.log(response);
      if (response.status === 200) {
        setIsModalOpen(false);
      }
    }
  };

  const handlecontactformsubmit = async (e) => {
    e.preventDefault();
    const id = Cookies.get("userId");
    const response = await axios.post(
      BaseUrl + `users/editContactInfo`,
      contactformData,{
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      }
    );
    console.log(response);
    if (response.status === 200) {
      setIsContactopen(false);
    }
  };

  const validateeducationForm = () => {
    let result = true;
    let errors = {};
    if (educationformData.school === "") {
      errors.school = "Please enter your school";
      result = false;
    }
    if (educationformData.degree === "") {
      errors.degree = "Please enter your degree";
      result = false;
    }
    setEducationError(errors);
    return result;
  };
  const handleducationformsubmit = async (e) => {
    e.preventDefault();
    const result = validateeducationForm();
    if (result) {
      const id = Cookies.get("userId");
      
      const response = await axios.post(
        BaseUrl + `users/addEducation`,
        educationformData,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
      console.log(response);
      if (response.status === 200) {
        setIsEducationopen(false);
      }
    }
  };
  const validateexperienceForm = () => {
    let result = true;
    let errors = {};

    if (experienceformData.title === "") {
      errors.title = "Please enter your title";
      result = false;
    }
    if (experienceformData.employment_type === "") {
      errors.employment_type = "Please enter your employment type";
      result = false;
    }
    if (experienceformData.company === "") {
      errors.company = "Please enter your company";
      result = false;
    }
    setExperienceError(errors);
    return result;
  };
  const handleexperienceformsubmit = async (e) => {
    e.preventDefault();
    const result = validateexperienceForm();
    if (result) {
      const id = Cookies.get("userId");
      console.log(experienceformData, "idddd");
      const response = await axios.post(
        BaseUrl + `users/addExperience`,
        experienceformData,{
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
          },
        }
      );
      console.log(response);
      if (response.status === 200) {
        setIsExperienceopen(false);
        setEducationFormData("");
      }
    }
  };

  const validateSkillForm = () => {
    let result = true;
    let errors = {};
    if (inputValue === "") {
      errors.inputValue = "Please enter your skill";
      result = false;
    }
    setskillError(errors);
    return result;
  };
  const handleskillfromsubmit = async (e) => {
    e.preventDefault();
    const result = validateSkillForm();
    const skillData = {
      skill_id: skillValue,
      experience_ids: selectedExperience,
      education_ids: selectedEducation,
      follow_skill: followSkill,
    };
    console.log(Cookies.get("token"),"token");
    if (result) {
      try {
        const response = await axios.post(
          BaseUrl + `users/addSkill`,
          skillData,
          {headers: { Authorization: `Bearer ${Cookies.get("token")}` }}
        );

        if (response.status === 200) {
          setIsSkillopen(false);
          setInputValue("");
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const validateSummaryForm = () => {
    let result = true;
    let errors = {};
    if (summaryValue === "") {
      errors.summaryValue = "Please enter the summary";
      result = false;
    }
    setSummaryError(errors);
    return result;
  };
  const handlesummaryfromsubmit = async (e) => {
    e.preventDefault();
    const result = validateSummaryForm();
    console.log(introformData, "introformData");
    const id = Cookies.get("userId");
    if (result) {
      try {
        const response = await axios.post(
          BaseUrl + `users/editaccount/${id}`,
          introformData,
          {}
        );

        if (response.status === 200) {
          setIsSummaryopen(false);
          setIsAboutopen(false);
          setSummaryValue("");
          getProfileData();
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const handleInputChange = (event) => {
    const input = event.target.value;
    console.log(input, "input");
    console.log(skillsRef.current, "skills");
    setInputValue(input);
    setskillError({ inputValue: "" });
    if (input.trim() === "") {
      setFilteredSkills(skillsRef.current.skill_name);
    } else {
      const filtered = skillsRef.current?.filter((skill) =>
        skill.skill_name.toLowerCase().includes(input.toLowerCase())
      );
      console.log(filtered, "filtered");

      setFilteredSkills([input, ...filtered]);
    }

    setIsDropdownOpen(true);
  };

  const handleSelectSkill = (skill_id, skill_name) => {
    setSkillValue(skill_id);
    setInputValue(skill_name);
    setIsDropdownOpen(false);
  };

  const handleClickOutside = (event) => {
    if (inputRef.current && !inputRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };
  document.addEventListener("mousedown", handleClickOutside);

  const handleImageChange = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    const validTypes = ["image/jpeg", "image/png", "image/webp", "image/gif"];
    if (!validTypes.includes(file.type)) {
      swal.fire({
        icon: "error",
        title: "Invalid File Type",
        text: "Only JPG, PNG, WEBP, and GIF files are allowed.",
      });
      return;
    }

    const maxSize = 3 * 1024 * 1024;
    if (file.size > maxSize) {
      swal.fire({
        icon: "warning",
        title: "File Too Large",
        text: "File size should be less than 2MB.",
      });
      return;
    }

    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => {
      const minWidth = 200;
      const minHeight = 200;
      const maxWidth = 1600;
      const maxHeight = 1600;

      if (img.width < minWidth || img.height < minHeight) {
        swal.fire({
          icon: "error",
          title: "Image Too Small",
          text: `Minimum dimensions required: ${minWidth}x${minHeight}px.`,
        });
        return;
      }

      if (img.width > maxWidth || img.height > maxHeight) {
        swal.fire({
          icon: "error",
          title: "Image Too Large",
          text: `Maximum allowed dimensions: ${maxWidth}x${maxHeight}px.`,
        });
        return;
      }

      setSelectedImage(file);
      setPImage(img.src);
      // setPreview(img.src);
    };
  };

  const onCropProfileComplete = useCallback(
    (croppedArea, croppedAreaPixels) => {
      setCroppedArea(croppedAreaPixels);
    },
    []
  );
  const saveCroppedProfileImage = async (e) => {
    e.preventDefault();
    if (!pimage) return;
    const croppedImage = await getCroppedProfileImg(pimage, croppedArea);
    setPreview(croppedImage);
    setPImage(null);
  };

  const formatDate = (dateString) => {

    return new Date(dateString).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
  };
  const handleProfileSubmit = async (event) => {
    event.preventDefault();

    if (!selectedImage) {
      swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please select an image",
      });
      return;
    }

    const formData = new FormData();
    formData.append("profile", selectedImage);

    const token = Cookies.get("token");

    try {
      const response = await axios.post(BaseUrl + "updateprofile", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      if (response.status === 200) {
        setSelectedImage(null);
        closeModalProfile();
      }

      console.log("Image uploaded successfully:", response.data);
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const handleBgImageChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      const validTypes = ["image/jpeg", "image/png", "image/webp"];
      if (!validTypes.includes(file.type)) {
        swal.fire(
          "Invalid File",
          "Only JPG, PNG, and WEBP are allowed.",
          "error"
        );
        return;
      }

      if (file.size > 3 * 1024 * 1024) {
        swal.fire("File Too Large", "Image should be under 2MB.", "error");
        return;
      }

      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        const minWidth = 250;
        const minHeight = 250;
        const maxWidth = 1800;
        const maxHeight = 1800;

        if (img.width < minWidth || img.height < minHeight) {
          swal.fire(
            "Image Too Small",
            `Minimum size required: ${minWidth}x${minHeight}px.`,
            "error"
          );
          return;
        }

        if (img.width > maxWidth || img.height > maxHeight) {
          swal.fire(
            "Image Too Large",
            `Maximum allowed size: ${maxWidth}x${maxHeight}px.`,
            "error"
          );
          return;
        }

        setSelectedBgImage(file);
        setImage(img.src);
        setBgPreview(null);
      };
    }
  };

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedArea(croppedAreaPixels);
  }, []);
  const saveCroppedImage = async (e) => {
    e.preventDefault();
    if (!image) return;
    const croppedImage = await getCroppedImg(image, croppedArea);
    setBgPreview(croppedImage);
    setImage(null);
  };
  const handleBgProfileSubmit = async (event) => {
    event.preventDefault();
    if (!selectedbgImage) {
      swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please select an image",
      });
      return;
    }
    const formData = new FormData();
    formData.append("bg_profile", selectedbgImage);
    const token = Cookies.get("token");

    try {
      const response = await axios.post(BaseUrl + "updateprofile", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      if (response.data.status === 200) {
        setSelectedImage(null);
        closeModalBgProfile();
      }

      console.log("Image uploaded successfully:", response.data);
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };
  const getGridClass = (count) => {
    switch (count) {
      case 1:
        return "grid-cols-1";
      case 2:
        return "grid-cols-2";
      case 3:
        return "grid-cols-2 grid-rows-2";
      case 4:
        return "grid-cols-2 grid-rows-2";
      default:
        return "grid-cols-2 grid-rows-2";
    }
  };

  const [likes, setLikes] = useState(0);
  const [liked, setLiked] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");

  const handleLike = () => {
    setLiked(!liked);
    setLikes(liked ? likes - 1 : likes + 1);
  };

  const handleCommentSubmit = (e) => {
    e.preventDefault();
    if (newComment.trim() !== "") {
      setComments([...comments, newComment]);
      setNewComment("");
    }
  };

  return (
    <>
      {isloading ? (
        <div className="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center z-10">
          <img src="/Images/loader.gif" className="h-16 w-16 bg-opacity-50" />
        </div>
      ) : (
        <div className="bg-[#F3F2EF] mt-14">
          <div className="container mx-auto flex flex-col lg:flex-row py-8 gap-4 px-4 sm:px-6 lg:px-8">
            <div className="w-full lg:w-3/4">
              <div className="bg-white rounded-t-lg">
                <div className="relative">
                  <div className="absolute top-5 right-5 bg-white rounded-full ">
                    <button
                      className="text-xl text-blue-500 hover:text-blue-600 rounded-full p-2"
                      onClick={openModalBgProfile}
                    >
                      <FaCamera />
                    </button>
                  </div>
                  {isModalBgProfile && (
                    <div className="fixed inset-0 bg-gray-800  bg-opacity-50 flex items-center justify-center z-10">
                      <div className="bg-white shadow-lg rounded-[30px] w-full max-w-2xl mx-auto border-8 border-gray-500">
                        <div className="flex justify-between items-center bg-gray-200 p-5 rounded-t-[30px]">
                          <h2 className="text-xl font-semibold">
                            Add background photo
                          </h2>
                          <button
                            onClick={closeModalBgProfile}
                            className="text-gray-500 hover:text-gray-700"
                          >
                            <i className="fas fa-times"></i>
                          </button>
                        </div>
                        <div className="px-5 py-4">
                          <form
                            onSubmit={handleBgProfileSubmit}
                            className="space-y-4"
                          >
                            <div className=" flex flex-col items-center p-4 border-2 border-dashed border-gray-300 rounded-lg hover:bg-gray-50 transition">
                              <input
                                key={inputKey}
                                type="file"
                                accept="image/*"
                                onChange={handleBgImageChange}
                                className="absolute w-full h-full opacity-0 cursor-pointer"
                              />
                              {image && (
                                <div className="relative w-full h-96 bg-black">
                                  <Cropper
                                    image={image}
                                    crop={crop}
                                    zoom={zoom}
                                    aspect={4 / 1}
                                    onCropChange={setCrop}
                                    onZoomChange={setZoom}
                                    onCropComplete={onCropComplete}
                                  />
                                  <button
                                    onClick={saveCroppedImage}
                                    className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-blue-500 text-white px-4 py-2 rounded"
                                  >
                                    Save Cropped Image
                                  </button>
                                </div>
                              )}
                              {bgpreview ? (
                                <div className="flex flex-col items-center">
                                  <img
                                    src={bgpreview}
                                    alt="Preview"
                                    className="mt-2 rounded-xl shadow-md border"
                                  />
                                </div>
                              ) : !image ? (
                                <>
                                  <div className=" mb-2 text-4xl text-gray-500 bg-gray-200 p-4 size-40 flex items-center justify-center rounded-md">
                                    <FaCamera />
                                  </div>

                                  <span className="text-gray-500">
                                    Upload a photo
                                  </span>
                                  <p className="text-sm text-gray-600 mt-2">
                                    Allowed size range: <b>200x200px</b> to{" "}
                                    <b>1000x1000px</b>
                                  </p>
                                </>
                              ) : null}
                            </div>
                            <button
                              // onClick={}
                              className="w-full bg-gradient-to-r from-blue-500 to-blue-700 text-white py-2 px-4 rounded-xl font-semibold shadow-md hover:shadow-lg hover:scale-105 transition transform"
                            >
                              Upload Image
                            </button>
                          </form>
                        </div>
                      </div>
                    </div>
                  )}
                  <img
                    src={bg_profile.current || "/Images/cover-img.jpg"}
                    alt="Creative design background"
                    className="w-full h-56 object-cover rounded-t-lg"
                  />
                  <div className="absolute bottom-8 left-4 transform translate-y-1/2">
                    <img
                      src={profile.current || "/Images/user-img.jpg"}
                      alt="Profile of Erikson George"
                      className="size-40 rounded-full border-4 border-white"
                    />
                    <button
                      className="absolute bottom-2 left-28 bg-white rounded-full text-4xl text-blue-500"
                      onClick={openModalProfile}
                    >
                      <IoIosAddCircleOutline />
                    </button>
                  </div>
                  {isModalProfile && (
                    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-10">
                      <div className="bg-white shadow-lg rounded-[30px] w-full max-w-2xl mx-auto border-8 border-gray-500">
                        <div className="flex justify-between items-center bg-gray-200 p-5 rounded-t-[30px]">
                          <h2 className="text-xl font-semibold">Add photo</h2>
                          <button
                            onClick={closeModalProfile}
                            className="text-gray-500 hover:text-gray-700"
                          >
                            <i className="fas fa-times"></i>
                          </button>
                        </div>
                        <div className="px-5 py-4">
                          <form
                            onSubmit={handleProfileSubmit}
                            className="space-y-4"
                          >
                            <div className=" flex flex-col items-center p-4 border-2 border-dashed border-gray-300 rounded-lg hover:bg-gray-50 transition">
                              <input
                                key={inputKey}
                                type="file"
                                id="image"
                                accept="image/*"
                                className="absolute w-full h-full opacity-0 cursor-pointer"
                                onChange={handleImageChange}
                              />

                              {pimage && (
                                <div className="relative w-full h-96 ">
                                  <Cropper
                                    image={pimage}
                                    crop={crop}
                                    zoom={zoom}
                                    aspect={4 / 4}
                                    onCropChange={setCrop}
                                    onZoomChange={setZoom}
                                    onCropComplete={onCropProfileComplete}
                                  />
                                  <button
                                    onClick={saveCroppedProfileImage}
                                    className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-blue-500 text-white px-4 py-2 rounded"
                                  >
                                    Save Cropped Image
                                  </button>
                                </div>
                              )}

                              {preview ? (
                                <div className="flex flex-col items-center">
                                  <img
                                    src={preview}
                                    alt="Preview"
                                    className="mt-2 w-40 h-40 object-cover rounded-xl shadow-md border"
                                  />
                                </div>
                              ) : !pimage ? (
                                <>
                                  <div className=" mb-2 text-4xl text-gray-500 bg-gray-200 p-4 size-40 flex items-center justify-center rounded-md">
                                    <FaCamera />
                                  </div>

                                  <span className="text-gray-500">
                                    Upload a photo
                                  </span>
                                  <p className="text-sm text-gray-600 mt-2">
                                    Allowed size range: <b>200x200px</b> to{" "}
                                    <b>1000x1000px</b>
                                  </p>
                                </>
                              ) : null}
                            </div>
                            <button
                              type="submit"
                              className="w-full bg-gradient-to-r from-blue-500 to-blue-700 text-white py-2 px-4 rounded-xl font-semibold shadow-md hover:shadow-lg hover:scale-105 transition transform"
                            >
                              Upload Image
                            </button>
                          </form>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="py-12 px-6">
                  <div className=" ">
                    <div className="flex flex-col items-end">
                      <button
                        className="text-2xl text-gray-500 hover:text-black rounded-full p-1"
                        onClick={openModal}
                      >
                        <MdOutlineEdit />
                      </button>

                      {isModalOpen && (
                        <div className="fixed inset-0 bg-gray-800 bg-opacity-40 flex items-center justify-center z-50 ">
                          <div className="bg-white shadow-lg rounded-[30px] w-full max-w-2xl mx-auto border-8 border-gray-500 ">
                            <div className="flex justify-between items-center bg-gray-200 p-5 rounded-t-[30px] ">
                              <h2 className="text-xl font-semibold">
                                Edit Introduction
                              </h2>
                              <button
                                onClick={closeModal}
                                className="text-gray-500 hover:text-gray-700"
                              >
                                <i className="fas fa-times"></i>
                              </button>
                            </div>
                            <form>
                              <div className="py-4 px-8 max-h-[500px] overflow-y-auto">
                                <p className="text-red-500 text-sm">
                                  * Indicates required
                                </p>

                                <div className="mb-4 mt-8">
                                  <label className="block text-sm font-bold mb-1">
                                    Name
                                    <span className="text-red-500 ">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    id="name"
                                    value={introformData.name || ""}
                                    onChange={onintroformDataChange}
                                    placeholder="Name"
                                    className="w-full border border-gray-300 rounded-md p-2"
                                  />
                                  <span className="text-red-500 ml-1 text-sm mb-1">
                                    {introerror.name}
                                  </span>
                                </div>
                                <div className="mb-4">
                                  <label
                                    className="block text-sm font-bold mb-1"
                                    htmlFor="additionalName"
                                  >
                                    Additional name
                                  </label>
                                  <input
                                    type="text"
                                    id="add_name"
                                    value={introformData.add_name || ""}
                                    onChange={onintroformDataChange}
                                    placeholder="Additional name"
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                  />
                                </div>
                                <div className="mb-4">
                                  <label className="block text-sm font-bold mb-1">
                                    Gender/Pronouns
                                  </label>
                                  <select
                                    id="gender"
                                    value={introformData.gender || ""}
                                    onChange={onintroformDataChange}
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                  >
                                    <option value="">Please Select</option>
                                    {options.map((option, index) => (
                                      <option key={index} value={option}>
                                        {option}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                <div className="mb-4">
                                  <label
                                    className="block text-sm font-bold mb-1"
                                    htmlFor="headline"
                                  >
                                    Headline{" "}
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <input
                                    id="headline"
                                    value={introformData.headline || ""}
                                    onChange={onintroformDataChange}
                                    type="text"
                                    placeholder="Web Designer at LogicSpice"
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                  />
                                  <span className="text-red-500 ml-1 text-sm mb-1">
                                    {introerror.headline}
                                  </span>
                                </div>
                                <div className="mb-4">
                                  <label className="block text-sm font-bold mb-1">
                                    Current Position
                                  </label>
                                  <label
                                    className="block text-sm font-bold mb-1"
                                    htmlFor="position"
                                  >
                                    Position{" "}
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <input
                                    id="position"
                                    value={introformData.position || ""}
                                    onChange={onintroformDataChange}
                                    type="text"
                                    placeholder="Web Designer at LogicSpice"
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                  />
                                  <span className="text-red-500 ml-1 text-sm mb-1">
                                    {introerror.position}
                                  </span>
                                </div>
                                <div className="mb-4">
                                  <label
                                    className="block text-sm font-bold mb-1"
                                    htmlFor="industry"
                                  >
                                    Industry{" "}
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <input
                                    id="industry"
                                    value={introformData.industry || ""}
                                    onChange={onintroformDataChange}
                                    type="text"
                                    placeholder="UI/UX Design"
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                  />
                                  <span className="text-red-500 ml-1 text-sm mb-1">
                                    {introerror.industry}
                                  </span>
                                </div>
                                <h1 className="text-2xl font-semibold mb-2">
                                  Education
                                </h1>
                                <p className="text-sm text-black mb-2">
                                  school
                                </p>
                                <div className="relative w-full bg-white mb-4 text-sm">
                                  <select
                                    id="education"
                                    className="appearance-none text-sm w-full border-b-2 bg-white border-gray-600 py-2 px-2 text-black focus:outline-none focus:border-black"
                                    value={selectedEdu}
                                    onChange={(e) =>
                                      setSelectedEducation(e.target.value)
                                    }
                                  >
                                    <option value="">Please Select</option>
                                    {education.map((option, index) => (
                                      <option key={index} value={option.id}>
                                        {option.name}
                                      </option>
                                    ))}
                                  </select>

                                  <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
                                    ▼
                                  </div>
                                </div>

                                <button
                                  className="flex items-center bg-blue-600 text-white px-4 py-2 rounded-md mb-6"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    educationopenModal();
                                  }}
                                >
                                  <i className="fas fa-plus mr-2"></i>
                                  Add new education
                                </button>
                                <div className="mb-6">
                                  <h2 className="text-xl font-semibold mb-2">
                                    Location
                                  </h2>
                                  <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Country/Region{" "}
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    id="country"
                                    value={introformData.country || ""}
                                    onChange={onintroformDataChange}
                                    className="w-full border border-gray-300 rounded-md p-2 "
                                  />
                                  <span className="text-red-500 ml-1 text-sm mb-1">
                                    {introerror.country}
                                  </span>
                                  <label className="block text-sm font-medium text-gray-700  mt-4 mb-1">
                                    City
                                  </label>
                                  <input
                                    id="city"
                                    value={introformData.city || ""}
                                    onChange={onintroformDataChange}
                                    type="text"
                                    className="w-full border border-gray-300 rounded-md p-2 "
                                  />
                                </div>
                                <div className="mb-6">
                                  <h2 className="text-xl font-semibold mb-2">
                                    Contact info
                                  </h2>
                                  <p className="text-sm text-gray-600 mb-4">
                                    Add or edit your profile URL, email, and
                                    more
                                  </p>
                                  <button
                                    className="flex items-center bg-blue-600 text-white px-4 py-2 rounded-md"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      contactopenModal();
                                    }}
                                  >
                                    <i className="fas fa-pen mr-2"></i>
                                    Edit Contact info
                                  </button>
                                  {iscontactOpen && (
                                    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-10 ">
                                      <div className="bg-white shadow-lg rounded-[30px] w-full max-w-2xl mx-auto border-8 border-gray-500 ">
                                        <div className="flex justify-between items-center bg-gray-200 p-5 rounded-t-[30px] ">
                                          <h2 className="text-xl font-semibold">
                                            Contact Information
                                          </h2>
                                          <button
                                            onClick={contactcloseModal}
                                            className="text-gray-500 hover:text-gray-700"
                                          >
                                            <i className="fas fa-times"></i>
                                          </button>
                                        </div>
                                        <div className="overflow-y-auto max-h-[500px]">
                                          <div className="flex  justify-between bg-blue-100 px-8 py-4">
                                            <div class="flex flex-col items-start mb-2">
                                              <h2 class="text-lg font-semibold">
                                                Notify network
                                              </h2>
                                              <p className="text-sm text-black w-96">
                                                Turn on to notify your network
                                                of key profile changes (such as
                                                new education) and work
                                                anniversaries. Updates can take
                                                up to 2 hours. Learn more about{" "}
                                                <a
                                                  href="#"
                                                  className="text-blue-600"
                                                >
                                                  sharing profile changes
                                                </a>
                                                .
                                              </p>
                                            </div>
                                            <div className="">
                                              <span className="text-gray-800 mr-2">
                                                On
                                              </span>
                                              <label className="switch">
                                                <input type="checkbox" />
                                                <span className="slider round"></span>
                                              </label>
                                            </div>
                                          </div>
                                          <form>
                                            <div className="py-4 px-8 max-h-[500px] overflow-y-auto ">
                                              <p className="text-red-500 text-sm mb-6">
                                                * Indicates required
                                              </p>

                                              <div className="mb-6">
                                                <label className="block text-gray-700 text-sm font-bold mb-2">
                                                  Phone number{" "}
                                                </label>
                                                <input
                                                  type="text"
                                                  id="phone_number"
                                                  value={
                                                    contactformData.phone_number ||
                                                    ""
                                                  }
                                                  onChange={
                                                    oncontactformDataChange
                                                  }
                                                  placeholder="Ex: 1234567898"
                                                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                />
                                              </div>
                                              <div className="mb-6">
                                                <label className="block text-gray-700 text-sm font-bold mb-2">
                                                  Phone type{" "}
                                                </label>
                                                <select
                                                  id="phone_type"
                                                  value={
                                                    contactformData.phone_type ||
                                                    ""
                                                  }
                                                  onChange={
                                                    oncontactformDataChange
                                                  }
                                                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                >
                                                  <option value="">
                                                    Please Select
                                                  </option>
                                                  <option value="Home">
                                                    Home
                                                  </option>
                                                  <option value="Work">
                                                    Work
                                                  </option>
                                                  <option value="Mobile">
                                                    Mobile
                                                  </option>
                                                </select>
                                              </div>
                                              <div className="mb-6">
                                                <label className="block text-gray-700 text-sm font-bold mb-2">
                                                  Address{" "}
                                                </label>
                                                <input
                                                  id="address"
                                                  value={
                                                    contactformData.address ||
                                                    ""
                                                  }
                                                  onChange={
                                                    oncontactformDataChange
                                                  }
                                                  type="text"
                                                  placeholder="your address"
                                                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                />
                                              </div>
                                              <div className="mb-6">
                                                <label className="block text-gray-700 text-sm font-bold mb-2">
                                                  Birthday
                                                </label>
                                                <div className="grid grid-cols-2 gap-4">
                                                  <select
                                                    id="birthday_month"
                                                    value={
                                                      contactformData.birthday_month ||
                                                      " "
                                                    }
                                                    onChange={
                                                      oncontactformDataChange
                                                    }
                                                    className="border-b-2 border-gray-400 p-2 w-full bg-transparent focus:outline-none focus:border-black"
                                                  >
                                                    <option value="">
                                                      Month
                                                    </option>
                                                    {months.map(
                                                      (month, index) => (
                                                        <option
                                                          key={index}
                                                          value={month}
                                                        >
                                                          {month}
                                                        </option>
                                                      )
                                                    )}
                                                  </select>
                                                  <select
                                                    id="birthday_date"
                                                    value={
                                                      contactformData.birthday_date ||
                                                      " "
                                                    }
                                                    onChange={
                                                      oncontactformDataChange
                                                    }
                                                    className="border-b-2 border-gray-400 p-2 w-full bg-transparent focus:outline-none focus:border-black"
                                                  >
                                                    <option value="">
                                                      Date
                                                    </option>
                                                    {dates.map((date) => (
                                                      <option
                                                        key={date}
                                                        value={date}
                                                      >
                                                        {date}
                                                      </option>
                                                    ))}
                                                  </select>
                                                </div>
                                              </div>
                                            </div>
                                          </form>
                                        </div>
                                        <div className="flex justify-end border-t-[1px] border-gray-200 py-4 px-8 ">
                                          <button
                                            type="submit"
                                            className="bg-blue-600 text-white px-6 py-2 rounded-lg"
                                            onClick={handlecontactformsubmit}
                                          >
                                            Save
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div>
                                  <h2 className="text-xl font-semibold mb-2">
                                    Website
                                  </h2>
                                  <p className="text-sm text-gray-600 mb-2">
                                    Add a link that will appear at the top of
                                    your profile
                                  </p>
                                  <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Link
                                  </label>
                                  <input
                                    type="text"
                                    id="website"
                                    value={introformData.website || ""}
                                    onChange={onintroformDataChange}
                                    className="w-full border border-gray-300 rounded-md p-2"
                                  />
                                </div>
                              </div>

                              <div className="flex justify-end border-t-[1px] border-gray-200 py-4 px-8 ">
                                <button
                                  type="submit"
                                  className="bg-blue-600 text-white px-6 py-2 rounded-lg"
                                  onClick={handleintroformsubmit}
                                >
                                  Save
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="flex justify-between">
                      <div className="flex items-center space-x-4 ">
                        <h1 className="text-2xl font-bold">
                          {introformData.name}
                        </h1>
                        <button className="ml-2 px-4 py-1 border border-dashed border-blue-500 text-blue-500 rounded-full text-sm hover:bg-blue-100">
                          <i className="fas fa-shield-alt"></i> Add verification
                          badge
                        </button>
                      </div>
                      <div className=" flex justify-between items-center">
                        <i className="fas fa-building text-3xl text-gray-500 "></i>
                        <p className="ml-2 text-gray-600 text-md w-48">
                          {experiencedata ? experiencedata[0]?.company : ""}
                        </p>
                      </div>
                    </div>
                    <p className=" text-gray-600">{introformData.position}</p>
                    <p className="text-gray-600">
                      {introformData.city}
                      {", "}
                      {introformData.country}{" "}
                      <a href="#" className="text-blue-500">
                        Contact us
                      </a>
                    </p>
                  </div>
                  <div className="relative inline-block mt-6 flex justify-start space-x-4">
                    <button className="px-4 py-1 bg-blue-500 text-white rounded-full hover:bg-blue-700">
                      Open to
                    </button>
                    <button className="px-4 py-1 border border-blue-500 text-blue-500 rounded-full hover:border-2 hover:text-blue-600 hover:border-blue-600 hover:bg-blue-100 transition-all duration-100 ease-in-out transform hover:scale-85">
                      Add profile section
                    </button>
                    <button className="px-4 py-1 border border-blue-500 text-blue-500 rounded-full hover:border-2 hover:text-blue-600 hover:border-blue-600 hover:bg-blue-100 transition-all duration-100 ease-in-out transform hover:scale-85">
                      Enhance profile
                    </button>
                    <button
                      className="px-4 py-1 border border-gray-500 text-gray-500 rounded-full 
                              hover:border-2 hover:text-gray-700 hover:border-gray-700 hover:bg-gray-100 
                              transition-all duration-100 ease-in-out transform hover:scale-85"
                      onClick={() => setIsResource(!isResource)}
                    >
                      Resources
                    </button>
                    {isResource && (
                      <div className="absolute left-96 mt-10">
                        <div className="w-64 bg-white shadow-lg rounded-lg p-4">
                          <ul className="space-y-2">
                            <li className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 p-2 rounded">
                              <i className="fas fa-share"></i>
                              <span>Send profile in a message</span>
                            </li>
                            <li className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 p-2 rounded">
                              <i className="fas fa-download"></i>
                              <span>Save to PDF</span>
                            </li>
                            <li className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 p-2 rounded">
                              <i className="fas fa-user"></i>
                              <span>Personal demographic information</span>
                            </li>
                            <li className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 p-2 rounded">
                              <i className="fas fa-bookmark"></i>
                              <span>Saved items</span>
                            </li>
                            <li className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 p-2 rounded">
                              <i className="fas fa-list-alt"></i>
                              <span>Activity</span>
                            </li>
                            <li className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 p-2 rounded">
                              <i className="fas fa-info-circle"></i>
                              <span>About this profile</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {!summaryValue && (
                <div className="bg-white  rounded-lg p-4 mt-4 w-full">
                  <h2 className="text-lg font-semibold ">Suggested for you</h2>
                  <div className="flex items-center mb-5">
                    <i className="fas fa-eye text-gray-500 mr-2"></i>
                    <span className="text-gray-500 text-sm">
                      Private to you
                    </span>
                  </div>

                  <div className="border border-gray-300 rounded-xl py-5 px-8 flex flex-col">
                    <div className="flex items-center space-x-2">
                      <img
                        src="https://placehold.co/40x40"
                        alt="Icon representing writing a summary"
                        className="w-10 h-10 mr-1"
                      />
                      <p className="text-gray-800 font-semibold">
                        Write a summary to highlight your personality or work
                        experience
                      </p>
                    </div>
                    <div className="mt-2">
                      <p className="text-gray-500 text-sm">
                        Members who include a summary receive up to 3.9 times as
                        many profile views.
                      </p>
                    </div>

                    <button
                      className="mt-2 bg-white text-blue-500 border-2 border-blue-500 w-fit px-3 py-1.5 rounded-full"
                      onClick={summaryopenModal}
                    >
                      Add a summary
                    </button>
                    {issummaryOpen && (
                      <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-10 ">
                        <div className="bg-white shadow-lg rounded-[30px] w-full max-w-2xl mx-auto border-8 border-gray-500 ">
                          <div className="flex justify-between items-center bg-gray-200 p-5 rounded-t-[30px] ">
                            <h2 className="text-xl font-semibold">
                              Let's add your summary
                            </h2>
                            <button
                              onClick={summarycloseModal}
                              className="text-gray-500 hover:text-gray-700"
                            >
                              <i className="fas fa-times"></i>
                            </button>
                          </div>
                          <form>
                            <div className="py-4 px-8 overflow-y-auto max-h-[500px]">
                              <p className="text-black text-[12px] mb-6">
                                You can write about your years of experience,
                                industry, or skills. Peope also talk about their
                                achievements orprevious job experiences.
                              </p>
                              <div className="mb-6 " ref={inputRef}>
                                <textarea
                                  type="text"
                                  value={summaryValue}
                                  rows={4}
                                  onChange={(e) => {
                                    setSummaryValue(e.target.value);
                                    setIntroFormData((prevData) => ({
                                      ...prevData,
                                      summary: e.target.value,
                                    }));
                                    setSummaryError((prevError) => ({
                                      ...prevError,
                                      summaryValue: "",
                                    }));
                                  }}
                                  className="w-full border-2 border-black rounded-md shadow-sm mb-0 py-2 px-2 focus:outline-none focus:ring-blue-600 focus:border-blue-600 "
                                  placeholder="Type to add your summary"
                                />
                                <span className="text-red-500 text-sm  ">
                                  {summaryerror.summaryValue}
                                </span>
                              </div>
                            </div>
                            <div className="flex justify-end border-t-[1px] border-gray-200 py-4 px-8 ">
                              <button
                                type="submit"
                                className="bg-blue-600 text-white px-6 py-2 rounded-lg"
                                onClick={handlesummaryfromsubmit}
                              >
                                Save
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {summaryValue && (
                <div className="mt-4 bg-white rounded-lg shadow-lg py-6">
                  <div className="flex justify-between items-center mb-4 ">
                    <h2 className="text-lg px-6 font-semibold">About</h2>

                    <div className="px-6">
                      <button
                        className="text-2xl text-gray-500 hover:text-black rounded-full p-1"
                        onClick={aboutopenModal}
                      >
                        <MdOutlineEdit />
                      </button>
                      {isAboutOpen && (
                        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-10 ">
                          <div className="bg-white shadow-lg rounded-[30px] w-full max-w-2xl mx-auto border-8 border-gray-500 ">
                            <div className="flex justify-between items-center bg-gray-200 p-5 rounded-t-[30px] ">
                              <h2 className="text-xl font-semibold">
                                Edit About
                              </h2>
                              <button
                                onClick={aboutcloseModal}
                                className="text-gray-500 hover:text-gray-700"
                              >
                                <i className="fas fa-times"></i>
                              </button>
                            </div>
                            <form>
                              <div className="py-4 px-8 overflow-y-auto max-h-[500px]">
                                <p className="text-black text-[12px] mb-6">
                                  You can write about your years of experience,
                                  industry, or skills. Peope also talk about
                                  their achievements orprevious job experiences.
                                </p>
                                <div className="mb-6 " ref={inputRef}>
                                  <textarea
                                    type="text"
                                    value={summaryValue}
                                    rows={4}
                                    onChange={(e) => {
                                      setSummaryValue(e.target.value);
                                      setIntroFormData((prevData) => ({
                                        ...prevData,
                                        summary: e.target.value,
                                      }));
                                      setSummaryError((prevError) => ({
                                        ...prevError,
                                        summaryValue: "",
                                      }));
                                    }}
                                    className="w-full border-2 border-black rounded-md shadow-sm mb-0 py-2 px-2 focus:outline-none focus:ring-blue-600 focus:border-blue-600 "
                                    placeholder="Type to add your summary"
                                  />
                                  <span className="text-red-500 text-sm  ">
                                    {summaryerror.summaryValue}
                                  </span>
                                </div>
                              </div>
                              <div className="flex justify-end border-t-[1px] border-gray-200 py-4 px-8 ">
                                <button
                                  type="submit"
                                  className="bg-blue-600 text-white px-6 py-2 rounded-lg"
                                  onClick={handlesummaryfromsubmit}
                                >
                                  Save
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="flex items-center space-x-4 px-8 my-4 border-gray-200">
                    <div className=" ">
                      <p className="text-gray-600 text-md">{summaryValue}</p>
                    </div>
                  </div>
                </div>
              )}

              <div className="mt-4 bg-white rounded-lg shadow-lg py-4">
                <h2 className="text-lg font-semibold px-6">Analytics</h2>
                <div className="flex items-center mb-5 px-6">
                  <i className="fas fa-eye text-gray-500 mr-2"></i>
                  <span className="text-gray-500 text-sm">Private to you</span>
                </div>

                <div className="grid grid-cols-3 gap-3 mt-4 px-6">
                  <div className=" flex gap-2">
                    <i className="fas fa-user-friends text-2xl mt-2"></i>
                    <div className="flex flex-col ">
                      <div className="text-lg font-semibold mt-2">
                        2 profile views
                      </div>
                      <div className="text-gray-500">
                        Discover who's viewed your profile.
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <i className="fas fa-chart-bar text-2xl mt-2"></i>
                    <div className="flex flex-col">
                      <div className="text-lg font-semibold mt-2">
                        0 post impressions
                      </div>
                      <div className="text-gray-500">
                        Start a post to increase engagement.
                        <br />
                        Past 7 days
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <i className="fas fa-search text-2xl mt-2"></i>
                    <div className="flex flex-col">
                      <div className="text-lg font-semibold mt-2">
                        1 search appearance
                      </div>
                      <div className="text-gray-500">
                        See how often you appear in search results.
                      </div>
                    </div>
                  </div>
                </div>
                <div className="border-t pt-2 mt-2">
                  <a
                    href="/user/analytics"
                    className="text-gray-500 flex items-center justify-center hover:text-blue-500 group"
                  >
                    Show all analytics{" "}
                    <i className="fas fa-arrow-right ml-2 transform transition-transform duration-300 ease-in-out group-hover:translate-x-2"></i>
                  </a>
                </div>
              </div>

              <div
                onClick={(e) => e.stopPropagation()}
                className="mt-4 bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden"
              >
                <div className="flex justify-between items-center p-4 border-b border-gray-200">
                  <div>
                    <h2 className="text-lg font-semibold text-gray-900">
                      Activity
                    </h2>
                    <p className="text-blue-500 text-sm hover:underline cursor-pointer">
                      291 followers
                    </p>
                  </div>
                  <button
                    className="text-blue-600 font-medium border border-blue-600 rounded-full px-4 py-1.5 text-sm hover:bg-blue-50 transition-colors"
                    onClick={() => setModalOpen(true)}
                  >
                    Create a post
                  </button>
                  {modalOpen && (
                    <PostModal
                      modalOpen={modalOpen}
                      closeModal={() => setModalOpen(false)}
                    />
                  )}
                </div>

                {postdata ? (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
                    {postdata?.slice(0, 2).map((post, index) => (
                      <div
                        key={index}
                        className="border border-gray-200 rounded-lg hover:shadow-md transition-shadow"
                        onClick={() => {
                          navigate("/user/editpost");
                        }}
                      >
                        <div className="flex items-start p-4">
                          <img
                            src={introformData.profile_image}
                            alt="Profile"
                            className="w-10 h-10 rounded-full mr-3 border border-gray-200"
                          />
                          <div className="flex-1">
                            <div className="flex items-center justify-between">
                              <div>
                                <p className="font-semibold text-gray-900 hover:text-blue-600 cursor-pointer">
                                  {introformData.name}
                                </p>
                                <p className="text-gray-500 text-xs">
                                  {formatDate(post.created_at)}
                                  <span className="mx-1">•</span>
                                  <span>
                                    {post.type === "event" ? "Event" : "Post"}
                                  </span>
                                </p>
                              </div>
                              <button className="text-gray-500 hover:text-gray-700">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-5 w-5"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z" />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>

                        {post.type === "event" ? (
                          <div className="px-4 py-2">
                            <div className="w-full bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 ">
                              {post.media && (
                                <div className="">
                                  <img
                                    src={
                                      post.media.url || "/Images/cover-img.jpg "
                                    }
                                    alt="Event Preview"
                                    className="w-full h-full object-cover"
                                  />
                                </div>
                              )}
                              <div className="flex justify-between p-4 bg-white">
                                <div className="w-[60%]">
                                  <p className="text-sm text-orange-600 font-semibold">
                                    {post.event.time}
                                  </p>
                                  <h2 className="text-lg font-bold text-gray-900 mt-1">
                                    {post.event.event_name}
                                  </h2>
                                  <p className="text-sm text-gray-600">
                                    Event by {post.event.organizer}
                                  </p>
                                  <p className="text-sm text-gray-600">
                                    {post.event.event_type === "online"
                                      ? post.event.event_type
                                      : post.event.address}
                                  </p>
                                </div>
                                <Link
                                  to={`/events/${post.event.slug}`}
                                  className="flex items-center  h-8 px-4 text-blue-600 border border-blue-600 rounded-full hover:bg-blue-100"
                                >
                                  View event
                                </Link>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <p className="text-[15px] px-4 pb-2 text-gray-800 leading-snug whitespace-pre-line">
                              {post.content}
                            </p>

                            <div
                              className={`grid gap-1 overflow-hidden ${
                                post.media.length === 1
                                  ? "grid-cols-1 min-h-[250px]"
                                  : "grid-cols-2 min-h-[250px]"
                              }`}
                            >
                              {post.media.slice(0, 4).map((image, index) => (
                                <div
                                  key={index}
                                  className={`relative group cursor-pointer flex justify-center ${
                                    post.media.length === 3 && index === 0
                                      ? "col-span-2"
                                      : ""
                                  }`}
                                  onClick={() => {
                                    setLightboxImages(post.media);
                                    // setSelectedImageIndex(index);
                                    setShowLightbox(true);
                                  }}
                                >
                                  <img
                                    src={image.url}
                                    alt={`preview-${index}`}
                                    className="h-full w-full object-cover"
                                  />
                                  {index === 3 && post.media.length > 4 && (
                                    <div className="absolute inset-0 flex items-center justify-center bg-black/40 text-white font-bold text-2xl">
                                      +{post.media.length - 4}
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>

                            {/* {showLightbox && selectedImageIndex !== null && (
                              <div className="fixed inset-0 flex items-center justify-center bg-black/90 z-[100] backdrop-blur-sm">
                                <div className="relative w-full h-full max-w-6xl max-h-[90vh] flex flex-col">
                                  <div className="flex justify-between items-center bg-black/50 text-white">
                                    <div className="text-sm text-gray-300">
                                      {selectedImageIndex + 1} /{" "}
                                      {lightboxImages.length}
                                    </div>
                                    <button
                                      className="p-2 rounded-full hover:bg-white/10 transition-colors"
                                      onClick={() => setShowLightbox(false)}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-6 w-6"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth={2}
                                          d="M6 18L18 6M6 6l12 12"
                                        />
                                      </svg>
                                    </button>
                                  </div>

                                  <div className="flex-1 relative flex items-center justify-center">
                                    {selectedImageIndex > 0 && (
                                      <button
                                        className="absolute left-4 md:left-8 p-3 rounded-full bg-black/50 text-white hover:bg-black/70 transition-all z-10"
                                        onClick={() =>
                                          setSelectedImageIndex(
                                            (prev) => prev - 1
                                          )
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          className="h-8 w-8"
                                          fill="none"
                                          viewBox="0 0 24 24"
                                          stroke="currentColor"
                                        >
                                          <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M15 19l-7-7 7-7"
                                          />
                                        </svg>
                                      </button>
                                    )}

                                    <div className="w-full h-full flex items-center justify-center">
                                      <img
                                        src={
                                          lightboxImages[selectedImageIndex].url
                                        }
                                        alt={`media-${selectedImageIndex}`}
                                        className="max-w-full max-h-full object-contain rounded-md"
                                        style={{
                                          cursor:
                                            lightboxImages.length > 1
                                              ? "pointer"
                                              : "default",
                                        }}
                                        onClick={() => {
                                          if (lightboxImages.length > 1) {
                                            setSelectedImageIndex((prev) =>
                                              prev === lightboxImages.length - 1
                                                ? 0
                                                : prev + 1
                                            );
                                          }
                                        }}
                                      />
                                    </div>

                                    {selectedImageIndex <
                                      lightboxImages.length - 1 && (
                                      <button
                                        className="absolute right-4 md:right-8 p-3 rounded-full bg-black/50 text-white hover:bg-black/70 transition-all z-10"
                                        onClick={() =>
                                          setSelectedImageIndex(
                                            (prev) => prev + 1
                                          )
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          className="h-8 w-8"
                                          fill="none"
                                          viewBox="0 0 24 24"
                                          stroke="currentColor"
                                        >
                                          <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M9 5l7 7-7 7"
                                          />
                                        </svg>
                                      </button>
                                    )}
                                  </div>

                                  {lightboxImages.length > 1 && (
                                    <div className="p-4 bg-black/50 flex justify-center overflow-x-auto">
                                      <div className="flex space-x-2">
                                        {lightboxImages.map((image, index) => (
                                          <div
                                            key={index}
                                            className={`w-16 h-16 rounded-md overflow-hidden cursor-pointer border-2 transition-all ${
                                              selectedImageIndex === index
                                                ? "border-blue-500"
                                                : "border-transparent"
                                            }`}
                                            onClick={() =>
                                              setSelectedImageIndex(index)
                                            }
                                          >
                                            <img
                                              src={image.url}
                                              alt={`thumbnail-${index}`}
                                              className="w-full h-full object-cover"
                                            />
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )} */}
                          </div>
                        )}
                        <div className="mt-3 flex items-center text-xs text-gray-500 space-x-4 px-4 ">
                          <span>{post.likes} likes</span>
                          <span>{post.comments.length} comments</span>
                        </div>

                        <div className="mt-2 flex border-t border-gray-100 pt-2">
                          <button
                            onClick={() => handleLike(post.id)}
                            className={`flex-1 flex items-center justify-center py-1.5 space-x-1 rounded-md hover:bg-gray-100 text-sm ${
                              likedPosts[post.id]
                                ? "text-red-500"
                                : "text-gray-500"
                            }`}
                          >
                            {likedPosts[post.id] ? <FaHeart /> : <FaRegHeart />}
                            <span>Like</span>
                          </button>
                          <button
                            onClick={() => handleShowComments(index)}
                            className="flex-1 flex items-center justify-center py-1.5 space-x-1 text-gray-500 rounded-md hover:bg-gray-100 text-sm"
                          >
                            <FaRegComment />
                            <span>Comment</span>
                          </button>
                          <button className="flex-1 flex items-center justify-center py-1.5 space-x-1 text-gray-500 rounded-md hover:bg-gray-100 text-sm">
                            <FaRegShareSquare />
                            <span>Share</span>
                          </button>
                        </div>

                        {showComments[index] && (
                          <div className="mt-3 space-y-3">
                            <div className="flex space-x-2">
                              <img
                                src={introformData.profile_image}
                                alt="You"
                                className="w-8 h-8 rounded-full"
                              />
                              <div className="flex-1 relative">
                                <input
                                  type="text"
                                  className="w-full p-2 pl-3 pr-10 border border-gray-300 rounded-full text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                                  placeholder="Add a comment..."
                                  value={newComments[post.id] || ""}
                                  onChange={(e) =>
                                    setNewComments((prev) => ({
                                      ...prev,
                                      [post.id]: e.target.value,
                                    }))
                                  }
                                />
                                <button
                                  onClick={(e) =>
                                    handleCommentSubmit(e, post.id)
                                  }
                                  className="absolute right-2 top-1/2 transform -translate-y-1/2 text-blue-500"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-8.707l-3-3a1 1 0 00-1.414 1.414L10.586 9H7a1 1 0 100 2h3.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a1 1 0 000-1.414z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                </button>
                              </div>
                            </div>

                            <div className="space-y-2 max-h-[200px] overflow-y-auto pr-2">
                              {recievedcomments[post.id]
                                ?.slice(0, 3)
                                .map((comment) => (
                                  <div
                                    key={comment.comment_id}
                                    className="flex space-x-2"
                                  >
                                    <img
                                      src={
                                        comment.userAvatar ||
                                        "/default-avatar.png"
                                      }
                                      alt="User"
                                      className="w-7 h-7 rounded-full"
                                    />
                                    <div className="flex-1">
                                      <div className="bg-gray-50 p-2 rounded-lg">
                                        <div className="font-semibold text-xs">
                                          {comment.userName}
                                        </div>
                                        <p className="text-gray-800 text-xs mt-1">
                                          {comment.comment}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="p-6 text-center">
                    <p className="text-gray-700 font-semibold mb-1">
                      You haven't posted yet
                    </p>
                    <p className="text-gray-500 text-sm mb-4">
                      Posts you share will be displayed here.
                    </p>
                    <button
                      className="text-blue-600 font-medium border border-blue-600 rounded-full px-4 py-1.5 text-sm hover:bg-blue-50 transition-colors"
                      onClick={() => setModalOpen(true)}
                    >
                      Create your first post
                    </button>
                  </div>
                )}

                {postdata?.length > 2 && (
                  <div className="border-t border-gray-200 p-4 text-center">
                    <a
                      href="/user/editpost"
                      className="text-gray-500 flex items-center justify-center hover:text-blue-500 group"
                    >
                      Show all activity{" "}
                      <i className="fas fa-arrow-right ml-2 transform transition-transform duration-300 ease-in-out group-hover:translate-x-2"></i>
                    </a>
                  </div>
                )}
              </div>

              <div className="mt-4 bg-white rounded-lg shadow-lg py-6">
                <div className="flex justify-between items-center mb-4 px-4">
                  <h2 className="text-xl font-semibold">Experience</h2>

                  <div className="flex space-x-2">
                    <button
                      className="text-2xl font-bold text-gray-500 hover:text-black rounded-full p-1"
                      onClick={experienceopenModal}
                    >
                      <IoMdAdd />
                    </button>
                    {isExperienceOpen && (
                      <div className="fixed inset-0 bg-gray-800 bg-opacity-40 flex items-center justify-center z-50 ">
                        <div className="bg-white shadow-lg rounded-[30px] w-full max-w-2xl mx-auto border-8 border-gray-500 ">
                          <div className="flex justify-between items-center bg-gray-200 p-5 rounded-t-[30px] ">
                            <h2 className="text-xl font-semibold">
                              Add Experience
                            </h2>
                            <button
                              onClick={experiencecloseModal}
                              className="text-gray-500 hover:text-gray-700"
                            >
                              <i className="fas fa-times"></i>
                            </button>
                          </div>
                          <div className="overflow-y-auto max-h-[500px]">
                            <div className="flex  justify-between bg-blue-100 px-8 py-4">
                              <div class="flex flex-col items-start mb-2">
                                <h2 class="text-lg font-semibold">
                                  Notify network
                                </h2>
                                <p className="text-sm text-black w-96">
                                  Turn on to notify your network of key profile
                                  changes (such as new education) and work
                                  anniversaries. Updates can take up to 2 hours.
                                  Learn more about{" "}
                                  <a href="#" className="text-blue-600">
                                    sharing profile changes
                                  </a>
                                  .
                                </p>
                              </div>
                              <div className="">
                                <span className="text-gray-800 mr-2">On</span>
                                <label className="switch">
                                  <input type="checkbox" />
                                  <span className="slider round"></span>
                                </label>
                              </div>
                            </div>
                            <form>
                              <div className="py-4 px-8 ">
                                <p className="text-red-500 text-sm mb-6">
                                  * Indicates required
                                </p>

                                <div className="mb-6">
                                  <label className="block text-gray-700 text-sm font-bold mb-2">
                                    Title{" "}
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    name="title"
                                    value={experienceformData.title}
                                    onChange={onexperienceformDataChange}
                                    placeholder="Ex: Retail Sales Manager"
                                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                  <span className="text-red-500 text-sm">
                                    {experienceError.title}
                                  </span>
                                </div>
                                <div className="mb-6">
                                  <label className="block text-gray-700 text-sm font-bold mb-2">
                                    Employment type{" "}
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <select
                                    className="mt-1 block w-full border-b-2 border-black rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-600 focus:border-blue-600 sm:text-sm"
                                    onChange={onexperienceformDataChange}
                                    name="employment_type"
                                    value={experienceformData.employment_type}
                                  >
                                    <option value="">Please Select</option>
                                    <option value="Full-time">Full-time</option>
                                    <option value="Part-time">Part-time</option>
                                    <option value="Self-employed">
                                      Self-employed
                                    </option>
                                    <options value="Freelance">
                                      Freelance
                                    </options>
                                    <options value="Internship">
                                      Internship
                                    </options>
                                    <options value="Trainee">Trainee</options>
                                  </select>
                                  <span className="text-red-500 text-sm">
                                    {experienceError.employment_type}
                                  </span>
                                </div>
                                <div className="mb-6">
                                  <label className="block text-gray-700 text-sm font-bold mb-2">
                                    Company or Organization
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    name="company"
                                    value={experienceformData.company}
                                    onChange={onexperienceformDataChange}
                                    placeholder="Company name"
                                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                  <span className="text-red-500 text-sm">
                                    {experienceError.company}
                                  </span>
                                </div>

                                <div className="mb-6">
                                  <label className="block text-gray-700 text-sm font-bold mb-2">
                                    Start Month
                                  </label>
                                  <div className="grid grid-cols-2 gap-4">
                                    <select
                                      id="start_month"
                                      name="start_month"
                                      value={experienceformData.start_month}
                                      onChange={onexperienceformDataChange}
                                      className="border-b-2 border-gray-400 p-2 w-full bg-transparent focus:outline-none focus:border-black"
                                    >
                                      <option value="">Month</option>
                                      {months?.map((month, index) => (
                                        <option key={index} value={month}>
                                          {month}
                                        </option>
                                      ))}
                                    </select>
                                    <select
                                      id="start_year"
                                      name="start_year"
                                      value={experienceformData.start_year}
                                      onChange={onexperienceformDataChange}
                                      className="border-b-2 border-gray-400 p-2 w-full bg-transparent focus:outline-none focus:border-black"
                                    >
                                      <option value="">Year</option>
                                      {years?.map((year) => (
                                        <option key={year} value={year}>
                                          {year}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                                <div className="mb-6">
                                  <label className="block text-gray-700 text-sm font-bold mb-2">
                                    End Month
                                  </label>
                                  <div className="grid grid-cols-2 gap-4">
                                    <select
                                      id="end_month"
                                      name="end_month"
                                      value={experienceformData.end_month}
                                      onChange={onexperienceformDataChange}
                                      className="border-b-2 border-gray-400 p-2 w-full bg-transparent focus:outline-none focus:border-black"
                                    >
                                      <option value="">Month</option>
                                      {months?.map((month, index) => (
                                        <option key={index} value={month}>
                                          {month}
                                        </option>
                                      ))}
                                    </select>
                                    <select
                                      id="end_year"
                                      name="end_year"
                                      value={experienceformData.end_year}
                                      onChange={onexperienceformDataChange}
                                      className="border-b-2 border-gray-400 p-2 w-full bg-transparent focus:outline-none focus:border-black"
                                    >
                                      <option value="">Year</option>
                                      {years?.map((year) => (
                                        <option key={year} value={year}>
                                          {year}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                                <div className="mb-6">
                                  <label
                                    className="block text-gray-700 text-sm font-bold mb-2"
                                    htmlFor="industry"
                                  >
                                    Location
                                  </label>
                                  <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    id="location"
                                    name="location"
                                    value={experienceformData.location}
                                    onChange={onexperienceformDataChange}
                                    type="text"
                                    placeholder="Ex: USA, New York"
                                  />
                                </div>
                                <div className="mb-6">
                                  <label className="block text-gray-700 text-sm font-bold mb-2">
                                    Location type
                                  </label>
                                  <select
                                    className="mt-1 block w-full border-b-2 border-black rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-600 focus:border-blue-600 sm:text-sm"
                                    name="location_type"
                                    value={experienceformData.location_type}
                                    onChange={onexperienceformDataChange}
                                  >
                                    <option>Please Select</option>
                                    <option value="On-site">On-site</option>
                                    <option value="Hybrid">Hybrid</option>
                                    <option value="Remote">Remote</option>
                                  </select>
                                </div>
                                <div className="mb-6">
                                  <label
                                    className="block text-gray-700 text-sm font-bold mb-2"
                                    htmlFor="description"
                                  >
                                    Description
                                  </label>
                                  <textarea
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    id="description"
                                    rows="4"
                                    name="description"
                                    value={experienceformData.description}
                                    onChange={onexperienceformDataChange}
                                  ></textarea>
                                </div>
                                <div className="mb-6">
                                  <label
                                    className="block text-gray-700 text-sm font-bold mb-2"
                                    htmlFor="profileHeadline"
                                  >
                                    Profile headline
                                  </label>
                                  <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    id="profileHeadline"
                                    type="text"
                                    name="headline"
                                    value={experienceformData.headline}
                                    onChange={onexperienceformDataChange}
                                  />
                                </div>
                                <div className="mb-6">
                                  <label className="block text-gray-700 text-sm font-normal mb-2">
                                    Where did you find this job ?
                                  </label>
                                  <select
                                    className="mt-1 block w-full border-b-2 border-black rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-600 focus:border-blue-600 sm:text-sm"
                                    name={"findjob"}
                                    value={experienceformData.findjob}
                                    onChange={onexperienceformDataChange}
                                  >
                                    <option value="">Please Select</option>
                                    <option value="LS LinkUP">LS LinkUP</option>
                                    <option value="Company website">
                                      Company website
                                    </option>
                                    <option value="Indeed">Indeed</option>
                                    <option value="Other job sites">
                                      overflow-y-auto max-h-[500px]{" "}
                                    </option>
                                    <option value="Staffing Agency">
                                      Staffing Agency
                                    </option>
                                    <option value="Other">Other</option>
                                  </select>
                                </div>
                                <div className="mb-6">
                                  <h2 className="text-lg font-semibold text-gray-700">
                                    Skills
                                  </h2>
                                  <p className="text-[10px] text-gray-500 mb-2">
                                    We recommend adding your top 5 used in this
                                    experience. They'll also appear in your
                                    Skills section.
                                  </p>
                                  <div className="flex flex-wrap gap-2 mb-3">
                                    {experienceformData.skills?.map(
                                      (skill, index) => (
                                        <span
                                          key={index}
                                          className="bg-gray-200 px-3 py-1 rounded-full text-gray-700"
                                        >
                                          {skill}
                                        </span>
                                      )
                                    )}
                                  </div>
                                  <button
                                    className="flex items-center text-blue-500 border border-blue-500 rounded-full px-4 py-2"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      openaddskillmodal();
                                    }}
                                  >
                                    <i className="fas fa-plus mr-2"></i> Add
                                    Skill
                                  </button>
                                  {showModal && (
                                    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
                                      <div className="bg-white p-5 rounded-lg shadow-lg w-80">
                                        <h3 className="text-lg font-semibold mb-3">
                                          Select Skills
                                        </h3>
                                        <div className="max-h-40 overflow-y-auto">
                                          {skills?.map((skill, index) => (
                                            <label
                                              key={index}
                                              className="flex items-center space-x-2 mb-2"
                                            >
                                              <input
                                                type="checkbox"
                                                checked={checkedSkills.includes(
                                                  skill.skill_name
                                                )}
                                                onChange={() =>
                                                  handleCheckboxChange(
                                                    skill.skill_name
                                                  )
                                                }
                                              />
                                              <span>{skill.skill_name}</span>
                                            </label>
                                          ))}
                                        </div>

                                        <div className="flex justify-end mt-4">
                                          <button
                                            onClick={() => setShowModal(false)}
                                            className="mr-3 px-4 py-2 border border-gray-300 rounded"
                                          >
                                            Cancel
                                          </button>
                                          <button
                                            onClick={saveexperienceSkills}
                                            className="px-4 py-2 bg-blue-500 text-white rounded"
                                          >
                                            Save
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className="mb-6">
                                  <h2 className="text-lg font-semibold text-gray-700">
                                    Media
                                  </h2>
                                  <p className="text-[10px] text-gray-500 mb-2">
                                    Add media like images, documents, sites or
                                    presentations. Learn more about{" "}
                                    <a href="#" className="text-blue-500">
                                      media file types supported
                                    </a>
                                  </p>
                                  <button className="flex items-center text-blue-500 border border-blue-500 rounded-full px-4 py-2">
                                    <i className="fas fa-plus mr-2"></i> Add
                                    media
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>
                          <div className="flex justify-end border-t-[1px] border-gray-200 py-4 px-8 ">
                            <button
                              type="submit"
                              className="bg-blue-600 text-white px-6 py-2 rounded-lg"
                              onClick={handleexperienceformsubmit}
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                    <Link to={"/user/editexperience"}>
                      <button className="text-2xl text-gray-500 hover:text-black rounded-full p-1">
                        <MdOutlineEdit />
                      </button>
                    </Link>
                  </div>
                </div>
                {experiencedata.map((experience, index) => (
                  <div className="flex items-center space-x-4 px-8 border-b my-4 border-gray-200">
                    
                    <i className="fas fa-briefcase text-3xl text-gray-500 mr-4"></i>
                    <div className="mb-4 ">
                      <h3 className="text-lg font-medium">
                        {experience.title}
                      </h3>
                      <p className="text-gray-600">{experience.company}</p>
                      <p className="text-gray-600">
                        {experience.start_month} {experience.start_year} -{" "}
                        {experience.end_month} {experience.end_year}
                      </p>
                      <div className="flex items-center space-x-2 mt-2">
                        <i className="fas fa-gem text-gray-600"></i>
                        {experience.skills.map((skill, index) => (
                          <span className="text-gray-600">{skill}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-4 bg-white rounded-lg shadow-lg py-4 px-4">
                <div className="border-dashed border-2 border-blue-500 rounded-lg  py-6">
                  <div className="flex justify-between items-center px-6">
                    <h2 className="text-xl font-semibold">Education</h2>
                    <div className="flex space-x-2">
                      <button className="text-2xl text-gray-500 hover:text-black rounded-full p-1">
                        <MdClose />
                      </button>
                      <Link to={"/user/editeducation"}>
                        <button className="text-2xl text-gray-500 hover:text-black rounded-full p-1">
                          <MdOutlineEdit />
                        </button>
                      </Link>
                    </div>
                  </div>
                  <p className="text-gray-600 mb-4 px-6">
                    Show your qualifications and be up to 2X more likely to
                    receive a recruiter InMail
                  </p>
                  {educationdata.map((education, index) => (
                    <div className="flex items-center mb-2 border-b px-6 py-2">
                      <i className="fas fa-school text-3xl text-gray-500 mr-4"></i>
                      <div>
                        <h3 className="text-lg font-semibold">
                          {education.school}
                        </h3>
                        <p className="text-gray-600">
                          {education.degree}, {education.field_of_study}
                        </p>
                        <p className="text-gray-600">
                          {education.start_year} - {education.end_year}
                        </p>
                      </div>
                    </div>
                  ))}

                  <div className="px-6 py-2">
                    <button
                      className="border border-blue-500 text-blue-500 rounded-full px-4 py-2 hover:bg-blue-50 "
                      onClick={(e) => {
                        e.preventDefault();
                        educationopenModal();
                      }}
                    >
                      Add education
                    </button>
                  </div>
                  {isEducationOpen && (
                    <div className="fixed inset-0 bg-gray-800 bg-opacity-40 flex items-center justify-center z-50 ">
                      <div className="bg-white shadow-lg rounded-[30px] w-full max-w-2xl mx-auto border-8 border-gray-500 ">
                        <div className="flex justify-between items-center bg-gray-200 p-5 rounded-t-[30px] ">
                          <h2 className="text-xl font-semibold">
                            Add Education
                          </h2>
                          <button
                            onClick={educationcloseModal}
                            className="text-gray-500 hover:text-gray-700"
                          >
                            <i className="fas fa-times"></i>
                          </button>
                        </div>
                        <div className="">
                          <div className="overflow-y-auto max-h-[500px]">
                            <div className="flex  justify-between bg-blue-100 px-8 py-4">
                              <div class="flex flex-col items-start mb-2">
                                <h2 class="text-lg font-semibold">
                                  Notify network
                                </h2>
                                <p className="text-sm text-black w-96">
                                  Turn on to notify your network of key profile
                                  changes (such as new education) and work
                                  anniversaries. Updates can take up to 2 hours.
                                  Learn more about{" "}
                                  <a href="#" className="text-blue-600">
                                    sharing profile changes
                                  </a>
                                  .
                                </p>
                              </div>
                              <div className="">
                                <span className="text-gray-800 mr-2">On</span>
                                <label className="switch">
                                  <input type="checkbox" />
                                  <span className="slider round"></span>
                                </label>
                              </div>
                            </div>
                            <form>
                              <div className="py-4 px-8 ">
                                <p className="text-red-500 text-sm mb-6">
                                  * Indicates required
                                </p>

                                <div className="mb-6">
                                  <label className="block text-gray-700 text-sm font-bold mb-2">
                                    School{" "}
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <input
                                    id="school"
                                    value={educationformData.school}
                                    onChange={oneducationformDataChange}
                                    type="text"
                                    placeholder="Ex: Boston University"
                                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                  <span className="text-red-500">
                                    {educationError.school}
                                  </span>
                                </div>

                                <div className="mb-6">
                                  <label className="block text-gray-700 text-sm font-bold mb-2">
                                    Degree
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <input
                                    id="degree"
                                    value={educationformData.degree}
                                    onChange={oneducationformDataChange}
                                    type="text"
                                    placeholder="Ex: Bachelor's"
                                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                  <span className="text-red-500">
                                    {educationError.degree}
                                  </span>
                                </div>
                                <div className="mb-6">
                                  <label
                                    className="block text-gray-700 text-sm font-bold mb-2"
                                    htmlFor="industry"
                                  >
                                    Field of Study
                                  </label>
                                  <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    id="field_of_study"
                                    value={educationformData.field_of_study}
                                    onChange={oneducationformDataChange}
                                    type="text"
                                    placeholder="Ex: Business"
                                  />
                                </div>

                                <div className="mb-6">
                                  <label className="block text-gray-700 text-sm font-bold mb-2">
                                    Start Date
                                  </label>
                                  <div className="grid grid-cols-2 gap-4">
                                    <select
                                      id="start_month"
                                      value={educationformData.start_month}
                                      onChange={oneducationformDataChange}
                                      className="border-b-2 border-gray-400 p-2 w-full bg-transparent focus:outline-none focus:border-black"
                                    >
                                      <option value="">Month</option>
                                      {months.map((month, index) => (
                                        <option key={index} value={month}>
                                          {month}
                                        </option>
                                      ))}
                                    </select>
                                    <select
                                      id="start_year"
                                      value={educationformData.start_year}
                                      onChange={oneducationformDataChange}
                                      className="border-b-2 border-gray-400 p-2 w-full bg-transparent focus:outline-none focus:border-black"
                                    >
                                      <option value="">Year</option>
                                      {years.map((year) => (
                                        <option key={year} value={year}>
                                          {year}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                                <div className="mb-6">
                                  <label className="block text-gray-700 text-sm font-bold mb-2">
                                    End Date
                                  </label>
                                  <div className="grid grid-cols-2 gap-4">
                                    <select
                                      id="end_month"
                                      value={educationformData.end_month}
                                      onChange={oneducationformDataChange}
                                      className="border-b-2 border-gray-400 p-2 w-full bg-transparent focus:outline-none focus:border-black"
                                    >
                                      <option value="">Month</option>
                                      {months.map((month, index) => (
                                        <option key={index} value={month}>
                                          {month}
                                        </option>
                                      ))}
                                    </select>
                                    <select
                                      id="end_year"
                                      value={educationformData.end_year}
                                      onChange={oneducationformDataChange}
                                      className="border-b-2 border-gray-400 p-2 w-full bg-transparent focus:outline-none focus:border-black"
                                    >
                                      <option value="">Year</option>
                                      {years.map((year) => (
                                        <option key={year} value={year}>
                                          {year}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                                <div className="mb-6">
                                  <label
                                    className="block text-gray-700 text-sm font-bold mb-2"
                                    htmlFor="grade"
                                  >
                                    Grade
                                  </label>
                                  <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    id="grade"
                                    value={educationformData.grade}
                                    onChange={oneducationformDataChange}
                                    type="text"
                                    placeholder=""
                                  />
                                </div>
                                <div className="mb-6">
                                  <label
                                    className="block text-gray-700 text-sm font-bold mb-2"
                                    htmlFor="activities and societies"
                                  >
                                    Activities and Societies
                                  </label>
                                  <textarea
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    id="activities"
                                    value={educationformData.activities}
                                    onChange={oneducationformDataChange}
                                    rows="4"
                                    placeholder="Ex: Alpha Phi Omega, Marching Band, Volleyball"
                                  ></textarea>
                                </div>
                                <div className="mb-6">
                                  <label
                                    className="block text-gray-700 text-sm font-bold mb-2"
                                    htmlFor="description"
                                  >
                                    Description
                                  </label>
                                  <textarea
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    id="description"
                                    value={educationformData.description}
                                    onChange={oneducationformDataChange}
                                    rows="4"
                                  ></textarea>
                                </div>

                                <div className="mb-6">
                                  <h2 className="text-lg font-semibold text-gray-700">
                                    Skills
                                  </h2>
                                  <p className="text-[10px] text-gray-500 mb-2">
                                    We recommend adding your top 5 used in this
                                    experience. They'll also appear in your
                                    Skills section.
                                  </p>
                                  <div className="flex flex-wrap gap-2 mb-3">
                                    {educationformData.skills?.map(
                                      (skill, index) => (
                                        <span
                                          key={index}
                                          className="bg-gray-200 px-3 py-1 rounded-full text-gray-700"
                                        >
                                          {skill}
                                        </span>
                                      )
                                    )}
                                  </div>
                                  <button
                                    className="flex items-center text-blue-500 border border-blue-500 rounded-full px-4 py-2"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      openaddskillmodal();
                                    }}
                                  >
                                    <i className="fas fa-plus mr-2"></i> Add
                                    Skill
                                  </button>
                                  {showModal && (
                                    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
                                      <div className="bg-white p-5 rounded-lg shadow-lg w-80">
                                        <h3 className="text-lg font-semibold mb-3">
                                          Select Skills
                                        </h3>
                                        <div className="max-h-40 overflow-y-auto">
                                          {skills?.map((skill, index) => (
                                            <label
                                              key={index}
                                              className="flex items-center space-x-2 mb-2"
                                            >
                                              <input
                                                type="checkbox"
                                                checked={checkedSkills.includes(
                                                  skill.skill_name
                                                )}
                                                onChange={() =>
                                                  handleCheckboxChange(
                                                    skill.skill_name
                                                  )
                                                }
                                              />
                                              <span>{skill.skill_name}</span>
                                            </label>
                                          ))}
                                        </div>

                                        <div className="flex justify-end mt-4">
                                          <button
                                            onClick={() => setShowModal(false)}
                                            className="mr-3 px-4 py-2 border border-gray-300 rounded"
                                          >
                                            Cancel
                                          </button>
                                          <button
                                            onClick={saveeducationSkills}
                                            className="px-4 py-2 bg-blue-500 text-white rounded"
                                          >
                                            Save
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className="mb-6">
                                  <h2 className="text-lg font-semibold text-gray-700">
                                    Media
                                  </h2>
                                  <p className="text-[10px] text-gray-500 mb-2">
                                    Add media like images, documents, sites or
                                    presentations. Learn more about{" "}
                                    <a href="#" className="text-blue-500">
                                      media file types supported
                                    </a>
                                  </p>
                                  <button className="flex items-center text-blue-500 border border-blue-500 rounded-full px-4 py-2">
                                    <i className="fas fa-plus mr-2"></i> Add
                                    media
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>
                          <div className="flex justify-end border-t-[1px] border-gray-200 py-4 px-8 ">
                            <button
                              type="submit"
                              className="bg-blue-600 text-white px-6 py-2 rounded-lg"
                              onClick={handleducationformsubmit}
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="mt-4 bg-white rounded-lg shadow-lg py-4">
                <div className="flex justify-between items-center mb-2 px-6">
                  <h2 className="text-lg font-semibold">Skills</h2>
                  <div className="flex space-x-2">
                    <button
                      className="text-2xl text-gray-500 hover:text-black rounded-full p-1 "
                      onClick={skillopenModal}
                    >
                      <IoMdAdd />
                    </button>
                    {isSkillOpen && (
                      <div className="fixed inset-0 bg-gray-800 bg-opacity-40 flex items-center justify-center z-50 ">
                        <div className="bg-white shadow-lg rounded-[30px] w-full max-w-2xl mx-auto border-8 border-gray-500 ">
                          <div className="flex justify-between items-center bg-gray-200 p-5 rounded-t-[30px] ">
                            <h2 className="text-xl font-semibold">Add Skill</h2>
                            <button
                              onClick={skillcloseModal}
                              className="text-gray-500 hover:text-gray-700"
                            >
                              <i className="fas fa-times"></i>
                            </button>
                          </div>
                          <form>
                            <div className="py-4 px-8 overflow-y-auto max-h-[500px]">
                              <p className="text-red-500 text-sm mb-6">
                                * Indicates required
                              </p>

                              <div className="mb-6" ref={inputRef}>
                                <label className="block text-gray-700 text-sm font-bold mb-2">
                                  Skill <span className="text-red-500">*</span>
                                </label>
                                <input
                                  type="text"
                                  value={inputValue}
                                  onChange={handleInputChange}
                                  onFocus={() => setIsDropdownOpen(true)}
                                  className="w-full border-b-2 border-black rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-600 focus:border-blue-600 sm:text-sm"
                                  placeholder="Type to search or add a skill..."
                                />
                                <span className="text-red-500 text-sm">
                                  {skillerror.inputValue}
                                </span>
                                {isDropdownOpen && (
                                  <ul className=" bg-white border border-gray-300 rounded-md mt-1 shadow-lg z-10 max-h-48 overflow-y-auto">
                                    {filteredSkills?.map((skill, index) => (
                                      <li
                                        key={index}
                                        onClick={() =>
                                          handleSelectSkill(
                                            skill.skill_id,
                                            skill.skill_name
                                          )
                                        }
                                        className="px-3 py-2 cursor-pointer hover:bg-blue-100"
                                      >
                                        {skill.skill_name}
                                      </li>
                                    ))}
                                  </ul>
                                )}
                              </div>
                              {inputValue && (
                                <div className="mb-6">
                                  <h1 className="text-lg font-medium">
                                    Show us where you used this skill
                                  </h1>
                                  <p className="text-[12px] text-gray-600 mb-6">
                                    75% of hirers value skill context. Select at
                                    least one item to show where you used this
                                    skill.
                                  </p>

                                  {experience.length > 0 && (
                                    <div className="mb-4">
                                      <h2 className="text-sm font-medium text-gray-400 mb-4">
                                        Experience
                                      </h2>
                                      {experience.map((exp) => (
                                        <div
                                          key={exp.id}
                                          className="flex items-center mb-6"
                                        >
                                          <input
                                            type="checkbox"
                                            checked={selectedExperience.includes(
                                              exp.id
                                            )}
                                            onChange={() =>
                                              handleExperienceChange(exp.id)
                                            }
                                            className="form-checkbox h-5 w-5 text-blue-600"
                                          />
                                          <label className="ml-2 text-md">
                                            {exp.name}
                                          </label>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                  {education?.length > 0 && (
                                    <div className="mb-4">
                                      <h2 className="text-sm font-medium text-gray-400 mb-4">
                                        Education
                                      </h2>
                                      {education.map((edu) => (
                                        <div
                                          key={edu.id}
                                          className="flex items-center mb-6"
                                        >
                                          <input
                                            type="checkbox"
                                            checked={selectedEducation.includes(
                                              edu.id
                                            )}
                                            onChange={() =>
                                              handleEducationChange(edu.id)
                                            }
                                            className="form-checkbox h-5 w-5 text-blue-600"
                                          />
                                          <label className="ml-2 text-md">
                                            {edu.name}
                                          </label>
                                        </div>
                                      ))}
                                    </div>
                                  )}

                                  <div>
                                    <div className="flex items-center">
                                      <input
                                        type="checkbox"
                                        className="form-checkbox h-5 w-5 text-blue-600"
                                        checked={followSkill}
                                        onChange={() =>
                                          setFollowSkill((prev) => !prev)
                                        }
                                      />
                                      <label className="ml-2 text-md">
                                        Follow this skill to keep up with
                                        relevant content.
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="flex justify-end border-t-[1px] border-gray-200 py-4 px-8 ">
                              <button
                                type="submit"
                                className="bg-blue-600 text-white px-6 py-2 rounded-lg"
                                onClick={handleskillfromsubmit}
                              >
                                Save
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    )}
                    <Link to={"/user/editskill"}>
                      <button className="text-2xl text-gray-500 hover:text-black rounded-full p-1">
                        <MdOutlineEdit />
                      </button>
                    </Link>
                  </div>
                </div>
                <div className=" gap-2 px-6 py-4">
                  {skilldata.length > 0 && (
                    <div className="grid grid-cols-2 gap-4">
                      {" "}
                      {skilldata.slice(0, 2).map((skill, index) => (
                        <div
                          key={index}
                          className="border rounded-lg p-4 flex items-center space-x-4"
                        >
                          {/* <img
                        src="https://placehold.co/50x50"
                        alt="Logo of LogicSpice Consultancy Private Ltd."
                        className="w-12 h-12"
                      /> */}
                          <i className="fas fa-lightbulb text-3xl text-gray-500 mr-4"></i>
                          <div>
                            <h3 className="text-lg font-semibold">
                              {skill.skill_name}
                            </h3>
                            {skill.experience.length > 0 ? (
                              <p className="text-gray-600">
                                {skill.experience
                                  .slice(0, 2)
                                  .map((exp, expIndex) => (
                                    <span key={expIndex}>
                                      {exp.name} at {exp.company}
                                      {expIndex !==
                                        skill.experience.length - 1 && <br />}
                                    </span>
                                  ))}
                              </p>
                            ) : (
                              <p className="text-gray-600">
                                No experience available
                              </p>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="border-t pt-4">
                  <Link
                    to="/user/editskill"
                    className="text-gray-500 flex items-center justify-center hover:text-blue-500 group"
                  >
                    Show all skills{" "}
                    <i className="fas fa-arrow-right ml-2 transform transition-transform duration-300 ease-in-out group-hover:translate-x-2"></i>
                  </Link>
                </div>
              </div>

              <div className="mt-4 bg-white rounded-lg shadow-lg py-4">
                <div className="flex justify-between items-center mb-2 px-6">
                  <h2 className="text-xl font-semibold mb-4 px-6">Interests</h2>
                  <div className="flex space-x-2">
                    <button className="text-2xl text-gray-500 hover:text-black rounded-full p-1 ">
                      <IoMdAdd />
                    </button>

                    <Link to={"#"}>
                      <button className="text-2xl text-gray-500 hover:text-black rounded-full p-1">
                        <MdOutlineEdit />
                      </button>
                    </Link>
                  </div>
                </div>
                <div className="flex items-center mb-4 px-6">
                  <a
                    href="#"
                    className="text-blue-500 border-b border-b-2 offset-2  border-blue-600"
                  >
                    Companies
                  </a>
                </div>
                <hr className="my-4" />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 px-6">
                  <div className="flex items-start ">
                    {/* <img
                  src="https://placehold.co/60x60"
                  alt="Company logo with abstract blue design"
                  className="w-12 h-12 rounded-none mr-4"
                /> */}
                    <i className="fas fa-building text-3xl text-gray-500 mr-4"></i>
                    <div className="flex-1">
                      <h3 className="font-semibold">Logicspice Softwares</h3>
                      <p className="text-gray-600">10,258 followers</p>
                      <button className="border border-[1px] border-dashed border-blue-500 text-blue-500 rounded-full px-4 py-1 mt-2 flex items-center">
                        <i className="fas fa-check mr-2"></i>Following
                      </button>
                    </div>
                  </div>
                  <div className="flex items-start ">
                    {/* <img
                  src="https://placehold.co/60x60"
                  alt="Company logo with abstract brown design"
                  className="w-12 h-12 rounded-none mr-4"
                /> */}
                    <i className="fas fa-building text-3xl text-gray-500 mr-4"></i>
                    <div className="flex-1">
                      <h3 className="font-semibold">Logicspice Softwares</h3>
                      <p className="text-gray-600">10,258 followers</p>
                      <button className="border border-[1px] border-dashed border-blue-500 rounded-full px-4 py-1 mt-2 text-blue-500 flex items-center">
                        <i className="fas fa-check mr-2"></i>Following
                      </button>
                    </div>
                  </div>
                </div>
                <hr className="my-4" />
                <div className="flex justify-center mt-4">
                  <button className="text-gray-600 flex items-center hover:text-blue-500 group">
                    Show all skills{" "}
                    <i className="fas fa-arrow-right ml-2 transform transition-transform duration-300 ease-in-out group-hover:translate-x-2"></i>
                  </button>
                </div>
              </div>

              <div className="mt-4 bg-white rounded-lg shadow-lg py-4 px-4">
                <div className="border border-gray-200 rounded-lg px-6 py-6">
                  <div className="flex items-center justify-between">
                    <h2 className="col-span-11 text-xl font-bold">Causes</h2>
                    <Link to={"#"}>
                      <button className="text-2xl text-gray-500 hover:text-black rounded-full ">
                        <MdOutlineEdit />
                      </button>
                    </Link>
                  </div>
                  <div className="mt-2 text-gray-700 grid grid-cols-12 gap-1">
                    <span className="col-span-2">Arts and Culture</span>
                    {/* <span className="col-span-1 text-center">•</span> */}
                    <span className="col-span-2">Children</span>
                    {/* <span className="col-span-1 text-center">•</span> */}
                    <span className="col-span-2">Education</span>
                    {/* <span className="col-span-1 text-center">•</span> */}
                    <span className="col-span-2">Health</span>
                    {/* <span className="col-span-1 text-center">•</span> */}
                    <span className="col-span-2">Science and Technology</span>
                    {/* <span className="col-span-1 text-center">•</span> */}
                    <span className="col-span-2">Social Services</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-1/4">
              <img
                src="https://placehold.co/200x200"
                alt="Profile picture"
                className="w-full h-48 object-cover rounded-t-lg"
              />
              <div className="bg-white rounded-lg shadow-lg py-4 mt-4">
                <h2 className="text-lg font-semibold mb-4 px-4">
                  Other members also viewed
                </h2>
                <div className="space-y-4">
                  <div className="flex flex-col items-start lg:items-center xl:items-start px-4">
                    <div className="flex items-start w-full space-x-4">
                      <img
                        src="https://placehold.co/50x50"
                        alt="Profile picture of Marie Clark"
                        className="w-12 h-12 rounded-full"
                      />
                      <div>
                        <h3 className="font-semibold">Marie Clark</h3>
                        <p className="text-sm text-gray-600">
                          HR Manager at The Row
                        </p>
                      </div>
                    </div>
                    <div className="w-full flex items-center justify-start">
                      <button className="mt-2 px-3 ml-14 lg:ml-0 xl:ml-14 py-1 justify-self-start border rounded-full text-gray-700 border-gray-300 hover:bg-gray-100">
                        <i className="fas fa-envelope mr-1"></i>send a message
                      </button>
                    </div>
                  </div>
                  <hr className="border-gray-300" />
                  <div className="flex flex-col items-start lg:items-center xl:items-start px-4">
                    <div className="flex items-start w-full space-x-4">
                      <img
                        src="https://placehold.co/50x50"
                        alt="Profile picture of Tom Karen"
                        className="w-12 h-12 rounded-full"
                      />
                      <div>
                        <h3 className="font-semibold">Tom Karen</h3>
                        <p className="text-sm text-gray-600">Project Manager</p>
                      </div>
                    </div>
                    <div className="w-full flex items-center justify-start">
                      <button className="mt-2 px-3 ml-14 lg:ml-0 xl:ml-14 py-1 border rounded-full text-gray-700 border-gray-300 hover:bg-gray-100">
                        <i className="fas fa-user-plus mr-1 "></i>To set up a
                        contact
                      </button>
                    </div>
                  </div>
                  <hr className="border-gray-300" />
                  <div className="flex flex-col items-start lg:items-center xl:items-start px-4">
                    <div className="flex items-start w-full space-x-4">
                      <img
                        src="https://placehold.co/50x50"
                        alt="Profile picture of Marie Clark"
                        className="w-12 h-12 rounded-full"
                      />
                      <div>
                        <h3 className="font-semibold">Marie Clark</h3>
                        <p className="text-sm text-gray-600">UI/UX Designer</p>
                      </div>
                    </div>
                    <div className="w-full flex items-center justify-start">
                      <button className="mt-2 px-3 ml-14 lg:ml-0 xl:ml-14 py-1 border rounded-full text-gray-700 border-gray-300 hover:bg-gray-100">
                        <i className="fas fa-envelope mr-1"></i>send a message
                      </button>
                    </div>
                  </div>
                  <hr className="border-gray-300" />
                  <div className="flex flex-col items-start lg:items-center xl:items-start px-4">
                    <div className="flex items-start w-full space-x-4">
                      <img
                        src="https://placehold.co/50x50"
                        alt="Profile picture of Tom Karen"
                        className="w-12 h-12 rounded-full"
                      />
                      <div>
                        <h3 className="font-semibold">Tom Karen</h3>
                        <p className="text-sm text-gray-600">Designer</p>
                      </div>
                    </div>
                    <div className="w-full flex items-center justify-start">
                      <button className="mt-2 px-3 ml-14 lg:ml-0 xl:ml-14 py-1 border rounded-full text-gray-700 border-gray-300 hover:bg-gray-100">
                        <i className="fas fa-user-plus mr-1 "></i>To set up a
                        contact
                      </button>
                    </div>
                  </div>
                  <hr className="border-gray-300" />
                  <div className="flex space-x-4 px-4">
                    <div className="flex justify-center mb-4 w-48">
                      <img
                        src="/Images/user-profile/Group.png"
                        alt="Yellow key icon"
                        className="w-12 h-12 rotate-12"
                      />
                    </div>
                    <div>
                      <div>
                        <h2 className="text-lg font-bold mb-2">
                          Unlock the full list
                        </h2>
                        <p className="text-gray-600 mb-4">
                          See who else is often viewed alongside you
                        </p>
                      </div>
                      <button className="bg-blue-600 text-white font-medium py-2 px-4 rounded-full mb-4">
                        Try Premium for ₹0
                      </button>
                      <p className="text-gray-600 text-sm mb-4">
                        1-month free with 24/7 support access. We’ll remind you
                        7 days before your trial ends.
                      </p>
                    </div>
                  </div>
                  <div className="border-t pt-2 mt-2">
                    <Link
                      to="#"
                      className="text-gray-500 flex items-center justify-center hover:text-blue-500 group"
                    >
                      Expand
                      <i className="fas fa-chevron-down ml-1"></i>
                    </Link>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-lg p-4 mt-4">
                <h2 className="text-xl font-semibold mb-4">
                  People you may know
                </h2>
                <div className="space-y-4">
                  <div className="flex flex-col items-start lg:items-center xl:items-start">
                    <div className="flex items-start w-full space-x-4">
                      <img
                        src="https://placehold.co/50x50"
                        alt="Portrait of Karl Mill"
                        className="w-12 h-12 rounded-full"
                      />
                      <div>
                        <p className="font-semibold">Karl Mill</p>
                        <p className="text-sm text-gray-600">Web Artist</p>
                      </div>
                    </div>
                    <div className="w-full flex items-center justify-start">
                      <button className="mt-2 px-3 ml-14 lg:ml-0 xl:ml-14 py-1 border rounded-full text-gray-700 border-gray-300 hover:bg-gray-100">
                        <i className="fas fa-user-plus mr-1"></i>To set up a
                        contact
                      </button>
                    </div>
                  </div>

                  <hr className="my-4" />
                  <div className="flex flex-col items-start lg:items-center xl:items-start">
                    <div className="flex items-start w-full space-x-4">
                      <img
                        src="https://placehold.co/50x50"
                        alt="Portrait of Tom Karen"
                        className="w-12 h-12 rounded-full"
                      />
                      <div>
                        <p className="font-semibold">Tom Karen</p>
                        <p className="text-sm text-gray-600">Web Designer</p>
                      </div>
                    </div>
                    <div className="w-full flex items-center justify-start">
                      <button className="mt-2 px-3 ml-14 lg:ml-0 xl:ml-14 py-1 border rounded-full text-gray-700 border-gray-300 hover:bg-gray-100">
                        <i className="fas fa-user-plus mr-1"></i>To set up a
                        contact
                      </button>
                    </div>
                  </div>
                  <hr className="my-4" />
                  <div className="flex flex-col items-start lg:items-center xl:items-start">
                    <div className="flex items-start w-full space-x-4">
                      <img
                        src="https://placehold.co/50x50"
                        alt="Portrait of Mila Teren"
                        className="w-12 h-12 rounded-full"
                      />
                      <div>
                        <p className="font-semibold">Mila Teren</p>
                        <p className="text-sm text-gray-600">Designer</p>
                      </div>
                    </div>
                    <div className="w-full flex items-center justify-start">
                      <button className="mt-2 px-3 ml-14 lg:ml-0 xl:ml-14 py-1 border rounded-full text-gray-700 border-gray-300 hover:bg-gray-100">
                        <i className="fas fa-user-plus mr-1"></i>To set up a
                        contact
                      </button>
                    </div>
                  </div>
                </div>
                <hr className="my-4" />
                <div className="flex justify-center mt-4">
                  <button className="text-gray-600 text-sm flex items-center">
                    Expand <i className="fas fa-chevron-down ml-1"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProfileUser;
